

import React, { memo, useCallback, useMemo, useState } from 'react';
import _isEmpty from 'lodash.isempty';
import { MenuButton } from '../../../../../ui-kit';
import TopupModal from './CreditMenuSubscription/components/TopupModal';
import CreditMenuSubscription from './CreditMenuSubscription';
import { getBucket } from '../../../../../common/utils';
import buildFinanceTeamRows from '../../../selectors/buildFinanceTeamRows';
import '../styles/_credits-info.scss';














function SubscriptionCreditsInfo({
  isUnlimited,
  creditBalance,
  creditType,
  teams = [],
  contractItemBalance = [],
  organisationInfo,
  hasAdminRole,
  orgTeams,
  openHubSpotConversationsWidget,
  onClickTopUpNow,
  financeLedgerEnabled = false,
  creditsRemaining,
  dollarsRemaining,
  currency,
  poolRemaining,
  teamBalances
}) {
  const useFinanceCredits =
    financeLedgerEnabled && typeof creditsRemaining === 'number';
  const [showTopupModal, setShowTopupModal] = useState(false);

  const onToggleTopupModal = useCallback(
    () => {
      if (onClickTopUpNow) {
        onClickTopUpNow();
        return;
      }
      setShowTopupModal(!showTopupModal);
    },
    [showTopupModal]
  );

  const onToggleLiveChatModal = useCallback(() => {
    openHubSpotConversationsWidget();
    setShowTopupModal(false);
  }, [showTopupModal]);

  // Build per-team rows for the finance-ledger TEAM-mode case.
  // Only computed when finance is enabled and we're in TEAM mode — mirrors the
  // admin/member split used by contractCreditsBalance below.
  const financeTeamRows = useMemo(() => {
    if (!financeLedgerEnabled || creditType !== 'TEAM') {
      return [];
    }
    return buildFinanceTeamRows({
      hasAdminRole,
      orgTeams,
      userTeams: teams,
      teamBalances: teamBalances || []
    });
  }, [financeLedgerEnabled, creditType, hasAdminRole, orgTeams, teams, teamBalances]);

  const contractCreditsBalance = useMemo(() => {
    const balances = !_isEmpty(contractItemBalance) ?
    getBucket(contractItemBalance) :
    [];

    // Return balance only for workspace for credit type SHARE
    if (creditType === 'SHARE') {
      return balances.
      filter((it) => it.product).
      map((it) => ({
        ...it,
        name: organisationInfo?.name,
        imageUrl: organisationInfo?.imageUrl
      }));
    }

    // Return all balances of teams for credit type of TEAM
    if (hasAdminRole) {
      return balances.
      filter((it) => !it.product).
      map((it) => ({
        ...it,
        name: it.teamName,
        // $FlowFixMe - Older version of flow not allowing optional chaining
        imageUrl: orgTeams?.find((team) => team.teamId === it.teamId)?.imageUrl
      }));
    }

    // Return balances for which user is part of a particular team for credit type of TEAM
    return balances.
    filter((it) => Boolean(teams.find((team) => team.teamId === it.teamId))).
    map((it) => ({
      ...it,
      name: it.teamName,
      // $FlowFixMe - Older version of flow not allowing optional chaining
      imageUrl: orgTeams?.find((team) => team.teamId === it.teamId)?.imageUrl
    }));
  }, [hasAdminRole, contractItemBalance, teams, orgTeams, organisationInfo]);

  const totalCreditsBalance = !_isEmpty(contractCreditsBalance) ?
  contractCreditsBalance.
  map((item) => item.credit).
  reduce((prev, next) => prev + next) :
  0;

  const totalTopupCreditsBalance = !_isEmpty(contractCreditsBalance) ?
  contractCreditsBalance.
  map((item) => item.topUpCredit).
  reduce((prev, next) => prev + next) :
  0;

  const contractBalanceToDisplay = totalCreditsBalance + totalTopupCreditsBalance;
  const balanceToDisplay = useFinanceCredits ? creditsRemaining : contractBalanceToDisplay;

  const creditsText = balanceToDisplay <= 1 ? 'credit' : 'credits';
  const checkForPaddingBottom = isUnlimited && creditType !== 'TEAM' || _isEmpty(contractItemBalance);

  if (!creditType) {
    return null;
  }

  return (
    <>
      <MenuButton
        id="credits-info"
        className={checkForPaddingBottom ? '' : 'padding-bottom'}
        buttonProps={{
          className: 'sub-v2-menu-button',
          prefix: isUnlimited &&
          'unlimited',

          children: `${
          isUnlimited ? '' : balanceToDisplay
          } ${creditsText}`
        }}>

        <CreditMenuSubscription
          creditType={creditType}
          isUnlimited={isUnlimited}
          creditBalance={creditBalance}
          teams={contractCreditsBalance.filter((it) => !it.product)}
          onToggleTopupModal={onToggleTopupModal}
          contractCreditsBalance={contractCreditsBalance}
          organisationInfo={organisationInfo}
          financeLedgerEnabled={financeLedgerEnabled}
          creditsRemaining={creditsRemaining}
          dollarsRemaining={dollarsRemaining}
          currency={currency}
          poolRemaining={poolRemaining}
          financeTeamRows={financeTeamRows} />

      </MenuButton>
      {showTopupModal &&
      <TopupModal
        visible={showTopupModal}
        onClose={onToggleTopupModal}
        openLiveChatModal={onToggleLiveChatModal} />}


    </>);

}

export default memo(SubscriptionCreditsInfo);